import moment from 'moment';

export const createFewDates = (startDate: string, count: number): string[] => {
  const startMoment = moment(startDate);
  return Array.from({ length: count }, (_, i) =>
    startMoment.clone().add(i, 'days').format('YYYY-MM-DD')
  );
};
